import { MessageCircle, Settings, User } from "lucide-react";
import { useLocation, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useNotificationsContext } from "@/contexts/NotificationsContext";

export default function BottomNavAgent() {
  const location = useLocation();
  const { isAdmin } = useAuth();
  const { unreadCount } = useNotificationsContext();

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 glass border-t border-border z-50"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="flex items-center justify-around h-16 max-w-md mx-auto">
        {/* Inbox */}
        <Link
          to="/agent"
          className={`flex flex-col items-center justify-center gap-1 px-4 py-2 rounded-lg transition-colors ${
            isActive("/agent")
              ? "text-primary"
              : "text-muted-foreground hover:text-foreground"
          }`}
        >
          <div className="relative">
            <MessageCircle size={20} />
            {unreadCount > 0 && (
              <span className="absolute -top-1.5 -right-2.5 min-w-[18px] h-[18px] flex items-center justify-center bg-destructive text-destructive-foreground text-[10px] font-bold rounded-full px-1 animate-pulse">
                {unreadCount > 99 ? '99+' : unreadCount}
              </span>
            )}
          </div>
          <span className="text-[10px] font-medium">Inbox</span>
        </Link>

        {/* Admin (only for admins) */}
        {isAdmin && (
          <Link
            to="/admin"
            className={`flex flex-col items-center justify-center gap-1 px-4 py-2 rounded-lg transition-colors ${
              isActive("/admin")
                ? "text-primary"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            <Settings size={20} />
            <span className="text-[10px] font-medium">Admin</span>
          </Link>
        )}

        {/* Profile */}
        <Link
          to="/profile"
          className={`flex flex-col items-center justify-center gap-1 px-4 py-2 rounded-lg transition-colors ${
            isActive("/profile")
              ? "text-primary"
              : "text-muted-foreground hover:text-foreground"
          }`}
        >
          <User size={20} />
          <span className="text-[10px] font-medium">Profil</span>
        </Link>
      </div>
    </nav>
  );
}
